import {isArray, isObject, isString} from "underscore";
import {useBOMRematchStore} from "../../../../hooks/bom_rematch";
import {useSelector} from "react-redux";

export default function useBomRematchHook() {
    const [{bom_data_list}] = useBOMRematchStore();
    let ColumnsForFinish = useSelector((state) => state.entities.system.stateToRedux['setColumnsForFinish']);
    const getDisplayStatusForFinishColumns = () => {
        let displayStatus = false;
        let mpn_cpn_flag = false;
        let unique_column_selected_flag = false;
        let part_number_flag = false;
        let part_number_data_check_flag = false;
        if (isObject(ColumnsForFinish) && Object.entries(ColumnsForFinish).length > 0) {
            let selected_column_list = {};
            Object.entries(ColumnsForFinish).map((v) => {
                if (selected_column_list[v[1].bomColumnName] !== undefined) {
                    selected_column_list[v[1].bomColumnName] = selected_column_list[v[1].bomColumnName] + 1;
                } else {
                    selected_column_list[v[1].bomColumnName] = 1;
                }
                if (v[1].bomColumnName === 'manufacturer_part_number' || v[1].bomColumnName === 'customer_part_number') {
                    mpn_cpn_flag = true;
                }
                if (v[1].bomColumnName === 'part_number') {
                    part_number_data_check_flag = v[1];
                }
            });
            if (Object.entries(selected_column_list).length > 0) {
                let c_total = 0;
                Object.entries(selected_column_list).map((v) => {
                    if (v[1] === 1) {
                        c_total = c_total + v[1];
                    }
                });
                if (c_total === Object.entries(selected_column_list).length) {
                    unique_column_selected_flag = true;
                }
            }
        } else {
            unique_column_selected_flag = true;
            part_number_flag = true;
        }
        if (part_number_data_check_flag && isArray(bom_data_list) && bom_data_list.length > 0) {
            let failed_count = 0;
            bom_data_list.map((v) => {
                if (v[part_number_data_check_flag.columnName] === undefined) {
                    failed_count++;
                }
                if (v[part_number_data_check_flag.columnName] !== undefined) {
                    let p = v[part_number_data_check_flag.columnName];
                    if (isString(p)) {
                        p = p.trim();
                        if (!p || p === '' || p === null) {
                            failed_count++;
                        }
                    }
                    if (!p || p === '' || p === null) {
                        failed_count++;
                    }
                }
            });
            if (failed_count < 1) {
                part_number_flag = true;
                // mpn_cpn_flag is optional if part_number_flag is available
                mpn_cpn_flag = true;
            }
        }
        if (mpn_cpn_flag === true) {
            // part_number_flag/part_number_data_check_flag is optional if mpn_cpn_flag is available
            part_number_flag = true;
            part_number_data_check_flag = true;
        }
        if (mpn_cpn_flag === true &&
            part_number_flag === true &&
            unique_column_selected_flag === true
        ) {
            displayStatus = true;
        }
        return {
            displayStatus,
            mpn_cpn_flag,
            part_number_flag,
            part_number_data_check_flag,
            unique_column_selected_flag,
            validation_flags: {
                part_number_available: part_number_data_check_flag,
                part_number_row_data_check_passed: part_number_flag,
                mpn_cpn_available: mpn_cpn_flag,
                unique_column_selected: unique_column_selected_flag,
            }
        };
    };

    return [getDisplayStatusForFinishColumns];
}
